export class getPatientDataByReferralURl {
  patientAccount: any;
  firstName: any;
  lastName: any;
  dateOfBirth: any;
  practiceCode: any;
  practiceName: any;
  practicePhone: any;
  zip: any;
  city: any;
  state: any;
  patientPhone: any;
  practiceAddress: any;
  practiceFax: any;
  speciality: any;
  address: any;
  ssn: any;
  referrals: Referral[];
  patientInsuranceInfo: insurance[];

}


export class Referral {
  suggesteD_PROVIDER_ID: any;
  referraL_ID: any;
  npi: any;
  firsT_NAME: any;
  lasT_NAME: any;
  speciality: any;
  phonE_NO: any;
  email: any;
  faX_NO: any;
  address: any;
  city: any;
  state: any;
  zip: any;
  confirmeD_BY_PATIENT: any;
  referraL_SENDING_METHOD: any;
  direcT_ADDRESS: any;
  senD_VIA_EMAIL: any;
  senD_VIA_SMS: any;

}

export class insurance {
  patienT_INSURANCE_ID: any;
  co_Payment: any;
  deductions: any;
  effective_Date: any;
  termination_Date: any;
  group_Name: any;
  filing_indicator: any;
  cO_PAYMENT_PER: any;
  group_Number: any;
  allowed_Visits: any;
  patienT_ACCOUNT: any;
  prI_SEC_OTH_TYPE: any;
  id: any;
  policY_NUMBER: any;
  relationship: any;
  date: any;
  inspayeR_DESCRIPTION: any;
  subscriber: any;
  insurancE_ID: any;
  insurancE_ADDRESS: any;
  insurancE_CITY: any;
  insurancE_STATE: any;
  insurancE_ZIP: any;
  relationshiP_DESCRIPTION: any;
  guarantoR_CODE: any;
}

export class selectedReferrals {
  referraL_ID: any;
  referral_FirstName: any;
  referral_LastName: any;
  npi: any;
  speciality: any;
  phonE_NO: any;
  email: any;
  confirmed_By_Patient: any;
  faX_NO: any;
  address: any;
  city: any;
  state: any;
  zip: any;
}

export class ReferralsRequest {
  patienT_ACCOUNT: any;
  practicE_CODE: any;
  referraL_ID: any;
  npi: any;
  firsT_NAME: any;
  lasT_NAME: any;
  speciality: any;
  phonE_NO: any;
  email: any;
  useR_NAME: any;
  confirmeD_BY_PATIENT: any;
  alreadY_SUGGESTED: any;
}

export class referringPhysician {
  name: any;
  phoneNumber: any;
  address: any;
  city: any;
  state: any;
  zipCode: any;
  speciality: any;
  fax: any;
  referralDetails: referralDetail[];
}

export class referralDetail {
  reason: any;
  diagnosis: any;
  refCode: any;
  refStartDate: any;
  refEndDate: any;
  refDate: any;
  allowedVisits: any;
  speciality: any;
  signedBy: any;
  signature: any;
}

export class addReferral {
  referraL_ID: any="";
  npi: any = "";
  firsT_NAME: any = "";
  lasT_NAME: any = "";
  speciality: any = "";
  phonE_NO: any = "";
  email: any = "";
  fax: any = "";
  address: any = "";
  city: any = "";
  state: any = "";
  zip: any = "";
  alreadY_SUGGESTED: any = "";
  patienT_ACCOUNT: any ="";
  practicE_CODE: any ="";
  useR_NAME: any="";
  confirmeD_BY_PATIENT: any = "";
  iS_INDIVIDUAL_PROVIDER: any = "";
  referraL_SENDING_METHOD: any = "";
  direcT_ADDRESS: any = "";
  senD_VIA_EMAIL: any = "";
  senD_VIA_SMS: any = "";


}
export class npiSearchResponse{
  npi:any;
  enumeration_type: any;
  provider_Credential_Text: any;
  is_Sole_Proprietor: any;
  description: any;
  provider_Last_Name: any;
  provider_First_Name: any;
  provider_Middle_Name: any;
  provider_Organization_Name: any;
  provider_First_Line_Business_Practice_Location_Address: any;
  provider_Business_Practice_Location_Address_City_Name: any;
  provider_Business_Practice_Location_Address_State_Name: any;
  provider_Business_Mailing_Address_Postal_Code: any;
  provider_Business_Practice_Location_Address_Postal_Code: any;
  provider_Business_Practice_Location_Address_Country_Code: any;
  provider_Business_Practice_Location_Address_Telephone_Number: any;
  provider_Business_Practice_Location_Address_Fax_Number: any;
  taxonomy_Code_1: any;
  taxonomy_Code_2: any;
  taxonomy_Code_3: any;
  taxonomy_Code_4: any;
}




